import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Kansas = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Kansas Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. No single required form; various disclosures about property
          conditions required.
        </Text>

        <Text style={styles.listItem}>
          2. Disclosure Statement: Required for sellers.
        </Text>

        <Text style={styles.listItem}>
          3. Radon Disclosure: Required if known radon issues exist.
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          5.{' '}
          <Text style={styles.underline}>
            Seller Property Condition Disclosure Statement
          </Text>{' '}
          – The seller must disclose extensive information concerning the
          condition of the real estate.
        </Text>
      </View>
    </View>
  );
};

export default Kansas;
